import { ThunkAction } from 'redux-thunk';
import { IContext, IState } from '../index';
import {
  fetchCreateMessageForOffer,
  ICreateMessageForOfferRequest,
  ICreateMessageForOfferResponse,
  ICreateMessageForOfferResponseError,
} from '../../repositories/demand/v2/create-message-for-offer';
import {
  demandOpenSuccessModal,
  demandRequestCreateMessageEndAction,
  demandRequestCreateMessageErrorAction,
  demandRequestCreateMessageStartAction,
} from '@cian/demand-trap-widget';
import {
  trackOpenSmsPopup,
  trackPhoneVerificationSuccess,
  trackSendFormSuccess,
  trackVerificationPhoneError,
} from '../../components/demand/utils/tracking';
import {
  EVerifyPhoneError,
  verifyPhoneCloseModalAction,
  verifyPhoneOpenModalAction,
  verifyPhoneSecondsToRetrySmsChangedAction,
  verifyPhoneSetErrorMessageAction,
} from '@cian/sms-validation-widget';

export const sendDemandRequest = (parameters: ICreateMessageForOfferRequest): ThunkAction<void, IState, IContext> => {
  return async (dispatch, getState, extra) => {
    const { httpApi } = extra;
    const { demand } = getState();

    if (!demand.createMessageRequest.isFetching) {
      dispatch(demandRequestCreateMessageStartAction(parameters));

      try {
        const { statusCode, response } = await fetchCreateMessageForOffer({ httpApi, parameters });

        if (statusCode !== 200) {
          return dispatch(
            demandRequestCreateMessageErrorAction((response as ICreateMessageForOfferResponseError).message),
          );
        }

        const responseData = response as ICreateMessageForOfferResponse;
        const isHomeowner = Boolean(parameters.isHomeowner);
        dispatch(demandRequestCreateMessageEndAction());

        switch (responseData.status) {
          case 'needPhoneConfirm':
            trackOpenSmsPopup(isHomeowner);
            dispatch(verifyPhoneSecondsToRetrySmsChangedAction(responseData.confirmTimeout as number));
            dispatch(verifyPhoneOpenModalAction());

            return;

          case 'codeError':
            trackVerificationPhoneError(isHomeowner);

            return dispatch(verifyPhoneSetErrorMessageAction(EVerifyPhoneError.NOT_CORRECT));

          default:
            if (parameters.confirmationCode) {
              trackPhoneVerificationSuccess(isHomeowner);
            }

            trackSendFormSuccess(isHomeowner);
            dispatch(verifyPhoneCloseModalAction());

            return dispatch(demandOpenSuccessModal());
        }
      } catch (exc) {
        return dispatch(demandRequestCreateMessageErrorAction(exc.message));
      }
    }

    return Promise.resolve();
  };
};
